import styled from "styled-components";

export const ChatPaneContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0; /* Allow shrinking in flex parent so scroll works */
  width: 100%;
  max-height: 100%;
  background: #fff;
  overflow: hidden;
  box-sizing: border-box;
`;

export const ChatPaneHeader = styled.div`
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
  position: relative;
`;

export const ChatPaneHeaderLeft = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  flex: 1;
`;

export const ChatPaneHeaderTitle = styled.h3`
  margin: 0;
  font-family: "Manrope", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
`;

export const ChatPaneHeaderRight = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  flex: 1;
  justify-content: flex-end;
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  transition: color 0.2s;

  &:hover {
    color: #0C53BB;
  }

  &:focus {
    outline: none;
    color: #0C53BB;
  }
`;

export const ChatPaneContent = styled.div`
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${(props) => (props.hasConversation ? "flex-start" : "center")};
  padding: 40px 20px;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: contain; /* Keep scroll inside this element */
  box-sizing: border-box;
`;

export const ChatPaneIcon = styled.div`
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChatPaneGreeting = styled.p`
  margin: 0 0 32px 0;
  font-family: "Manrope", sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #374151;
  text-align: center;
`;

export const ChatPaneButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  max-width: 460px;
  justify-content: center;
`;

export const ChatPaneButton = styled.button`
  height: 33px;
  padding: 12px 16px;
  background: #F1F6FE;
  border: 1px solid #C3D5F1;
  border-radius: 32px;
  font-family: "Manrope", sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 100%;
  letter-spacing: 0%;
  color: #0A4296;
  cursor: pointer;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  white-space: nowrap;
  width: auto;
  min-width: fit-content;

  &:hover {
    background: #E3EDFC;
    border-color: #A8C4E8;
  }

  &:focus {
    outline: none;
    border-color: #0A4296;
    box-shadow: 0 0 0 3px rgba(10, 66, 150, 0.1);
  }
`;

export const ChatPaneInputWrapper = styled.div`
  padding: 16px 20px;
  border-top: 1px solid #e5e7eb;
  background: #fff;
  flex-shrink: 0; /* Prevent input wrapper from shrinking */
  min-height: fit-content; /* Ensure it maintains its height */
  box-sizing: border-box;
`;

export const ChatPaneInputContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f9fafb;
  padding: 0;
  transition: all 0.2s;

  &:focus-within {
    border-color: #0C53BB;
    background: #fff;
    box-shadow: 0 0 0 3px rgba(12, 83, 187, 0.1);
  }
`;

export const ChatPaneInput = styled.input`
  flex: 1;
  padding: 12px 8px;
  border: none;
  background: transparent;
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  color: #374151;
  outline: none;

  &::placeholder {
    color: #9ca3af;
  }
`;

export const ChatPaneInputActions = styled.div`
  display: flex;
  align-items: center;
  padding: 0 8px;
`;

export const CancelButton = styled.button`
  appearance: none;
  border: 0;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  font-family: "Manrope", sans-serif;
  font-size: 12px;
  font-weight: 600;
  padding: 6px 4px;
  white-space: nowrap;

  &:hover,
  &:focus-visible {
    color: #0c53bb;
    outline: none;
    text-decoration: underline;
  }
`;

export const ChatMessagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  width: 100%;
  max-width: 100%;
  gap: 16px;
  flex-shrink: 0; /* Let content define height; parent ChatPaneContent scrolls */
`;

export const ChatMessage = styled.div`
  display: flex;
  flex-direction: column;
  // gap: 8px;
  width: 100%;
`;

export const UserMessage = styled.div`
  align-self: flex-end;
  background: #073270;
  border: 1px solid #C3D5F1;
  border-radius: 16px 4px 16px 16px;
  padding: 12px 16px;
  max-width: 80%;
  font-family: "Manrope", sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  word-wrap: break-word;
`;

export const AIMessage = styled.div`
  align-self: flex-start;
  background: #fff;
  // border: 1px solid #e5e7eb;
  // border-radius: 16px 16px 16px 4px;
  padding: 12px 16px;
  max-width: 100%;
  width: 100%;
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #374151;
  line-height: 1.5;
  word-wrap: break-word;
`;

export const MessageParagraph = styled.p`
  margin: 0 0 14px 0;
  white-space: pre-wrap;
  line-height: 1.6;
  
  &:last-child {
    margin-bottom: 10px;
  }
`;

/* Markdown answer body. Lives inside MessageParagraph (which is
   pre-wrap for legacy plain-text answers), so it resets white-space
   and styles the markdown blocks the agentic engine emits. The
   last paragraph renders inline so a trailing citation chip stays on
   the same line as the sentence it supports. */
export const MarkdownBody = styled.span`
  display: inline;
  white-space: normal;

  & p {
    display: block;
    margin: 0 0 10px;
    line-height: 1.6;
  }
  & p:last-child {
    display: inline;
    margin: 0;
  }
  & ul,
  & ol {
    margin: 4px 0 10px;
    padding-left: 20px;
  }
  & li {
    margin: 2px 0;
    line-height: 1.5;
  }
  & h1,
  & h2,
  & h3,
  & h4 {
    margin: 12px 0 6px;
    font-weight: 700;
    font-size: 15px;
    line-height: 1.35;
  }
  & h1 {
    font-size: 17px;
  }
  & h2 {
    font-size: 16px;
  }
  & table {
    display: block;
    max-width: 100%;
    overflow-x: auto;
    border-collapse: collapse;
    margin: 6px 0 12px;
  }
  & th,
  & td {
    border: 1px solid #d0d5dd;
    padding: 4px 8px;
    font-size: 13px;
    text-align: left;
  }
  & th {
    background: #f2f4f7;
    font-weight: 600;
  }
  & blockquote {
    border-left: 3px solid #d0d5dd;
    margin: 6px 0;
    padding-left: 10px;
    color: #475467;
  }
  & code {
    background: #f2f4f7;
    border-radius: 4px;
    padding: 1px 4px;
    font-size: 12.5px;
  }
  & hr {
    border: none;
    border-top: 1px solid #e4e7ec;
    margin: 10px 0;
  }
`;

export const DocumentHeading = styled.h3`
  margin: 20px 0 8px 0;
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
`;

export const DocumentList = styled.ol`
  margin: 0;
  padding-left: 20px;
  list-style-type: decimal;
`;

export const DocumentListItem = styled.li`
  margin: 0 0 12px 0;
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #374151;
  line-height: 1.5;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const DocumentField = styled.div`
  margin: 0;
  font-family: "Manrope", sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  line-height: 1.5;
`;

export const MatterNameHeading = styled.div`
  margin: 0 0 4px 0;
  font-family: "Manrope", sans-serif;
  font-size: 13px;
  font-weight: 700;
  line-height: 21px;
  letter-spacing: 0%;
  color: #374151;
`;

export const RelatedFileText = styled.div`
  margin: 8px 0 0 0;
  font-family: "Manrope", sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  line-height: 1.5;
`;

export const RelatedFileLink = styled.a`
  color: #0C53BB;
  text-decoration: none;
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }
`;

export const InlineCitationButton = styled.button`
  appearance: none;
  border: 1px solid #9bb9df;
  border-radius: 999px;
  background: #f4f8fd;
  color: #0c53bb;
  cursor: pointer;
  font-family: "Manrope", sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  margin: 2px 6px 6px 0;
  padding: 1px 8px;

  &:hover,
  &:focus-visible {
    background: #e8f1fc;
    border-color: #0c53bb;
    outline: none;
  }
`;

export const LoaderMessage = styled.div`
  align-self: flex-start;
  background: #fff;
  padding: 12px 16px;
  max-width: 80%;
  font-family: "Manrope", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #0C53BB;
  display: flex;
  align-items: center;

  svg {
    color: #0C53BB;
    flex-shrink: 0;

    /* Required for 3D effect */
    perspective: 800px;

    /* Big star - coin flip sideways (Y axis) */
   #big-star {
  animation: starFlip 1.6s ease-in-out infinite;
  transform-origin: center;
  transform-box: fill-box;
  backface-visibility: hidden;
}

    /* Plus icon 1 rotation - only direct path children, exclude big-star */
    > path:nth-of-type(1) {
      animation: plusRotate1 2s linear infinite;
      transform-origin: center;
      transform-box: fill-box;
    }

    /* Plus icon 2 rotation - only direct path children, exclude big-star */
    > path:nth-of-type(2) {
      animation: plusRotate2 1.8s linear infinite reverse;
      transform-origin: center;
      transform-box: fill-box;
    }
  }

  /* Coin flip animation sideways (forward and back only) */
@keyframes starFlip {
  0% {
    transform: rotateY(0deg);
  }
  50% {
    transform: rotateY(180deg);
  }
  100% {
    transform: rotateY(360deg);
  }
}

  @keyframes plusRotate1 {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes plusRotate2 {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ChatOptionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 8px;
  width: 100%;
`;

export const SmartAssistantLabel = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  // background: #0C53BB;
  border-radius: 16px;
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0px;
  color: #0C53BB;
  margin-bottom: 8px;
  width: fit-content;
  
  svg {
    color: #0C53BB;
    flex-shrink: 0;
  }
`;

export const FactBox = styled.div`
  width: 420px;
  min-height: 39px;
  border-radius: 6px;
  border: 1px solid ${props => props.isSelected ? '#0C53BB' : '#DDE2E9'};
  background: ${props => props.isSelected ? '#F1F6FE' : '#FFFFFF'};
  padding: 12px 12px;
  margin-bottom: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  transition: all 0.2s;
  
  &:hover {
    border-color: #0C53BB;
    box-shadow: 0 0 0 1px rgba(12, 83, 187, 0.1);
  }
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const FactContent = styled.div`
  flex: 1;
  font-family: "Manrope", sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.5;
  color: #0C53BB;
  text-decoration: underline;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FactPageNumber = styled.div`
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0%;
  color: ${props => props.isSelected ? '#0C53BB' : '#48566B'};
  padding: 4px 8px;
  border-radius: 4px;
  flex-shrink: 0;
  white-space: nowrap;
`;

export const CollapseIcon = styled.img`
  width: 14px;
  height: 14px;
  margin-left: 4px;
  transition: transform 0.2s;
  transform: ${props => props.open ? 'rotate(180deg)' : 'rotate(0deg)'};
`;
